import { ResolverTag } from '@ps/web-core-enums';
import type { TranslationTag } from '@ps/web-core-intl';
import { Translation } from '@ps/web-shared-components';
import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import useWizardContext from '@swf/core/hooks/useWizardContext';
import { select } from '@swf/core/store';

import { CardType } from '../../../../types/cardType';
import Container from '../../../Container/Container';
import NativeAppLink from '../../../NativeAppLink/NativeAppLink';

import {
  TXTWCL_Continue,
  TXTWCL_Please_go_to_the_Payconiq_app__ELL,
  TXTWCL_Tap_XContinueX_to_be_redirecte_ELL,
  TXTWCL_Your_transaction_can_not_be_co_ELL,
  TXTWCL_Your_transaction_can_not_be_co_ELL_1
} from './DepositOpenExternalApp.messages.json';
import { container, continueButton } from './DepositOpenExternalApp.scss';

const INFO_TEXT: Partial<Record<CardType, TranslationTag>> = {
  [CardType.Payconiq]: TXTWCL_Please_go_to_the_Payconiq_app__ELL
};

const DepositOpenExternalApp: React.FC = () => {
  const {
    data: { depositResultContext }
  } = useWizardContext();
  const [error, setError] = useState(false);
  const appNotInstalled = useCallback(() => setError(true), [setError]);
  const infoText = depositResultContext?.cardType && INFO_TEXT[depositResultContext.cardType];
  const isAndroid = useSelector(select.device.isAndroid);
  const errorText = isAndroid
    ? TXTWCL_Your_transaction_can_not_be_co_ELL
    : TXTWCL_Your_transaction_can_not_be_co_ELL_1;
  const errorResolverTag = isAndroid
    ? ResolverTag.PayconiqAppUrlAndroid
    : ResolverTag.PayconiqAppUrlIos;

  return (
    <Container
      page={DepositOpenExternalApp}
      headerProps={{
        title: <Translation {...TXTWCL_Tap_XContinueX_to_be_redirecte_ELL} />,
        buttons: {}
      }}
      showFooter
    >
      <div className={container}>
        {infoText && <Translation {...infoText} tagName="p" />}
        <NativeAppLink
          href={depositResultContext?.appSchemaUrl || ''}
          onFallback={appNotInstalled}
          onIgnored={appNotInstalled}
          onReturn={window.close}
          translation={TXTWCL_Continue}
          className={continueButton}
        />
      </div>
      {error && (
        <Translation
          {...errorText}
          values={{
            a: (msg: React.ReactNode) => (
              <ResolverLink resolverTag={errorResolverTag}>{msg}</ResolverLink>
            )
          }}
          tagName="p"
        />
      )}
    </Container>
  );
};

DepositOpenExternalApp.displayName = 'DepositOpenExternalApp';

export default DepositOpenExternalApp;
